// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b03e3c98","879":"98b5e3b6"}[chunkId] + ".chunk.js";
};